import type { DealSearchCondition } from './Deal';

export const TYPE_OPTIONS = [
  { label: '案件単位', value: 'deals' },
  { label: '施工項目単位', value: 'deal_constructions' }
] as const;

export const ENCODING_OPTIONS = [
  { label: 'Shift_JIS', value: 'shift_jis' },
  { label: 'UTF-8', value: 'utf8' }
] as const;

export type Type = (typeof TYPE_OPTIONS)[number]['value'];
export type Encoding = (typeof ENCODING_OPTIONS)[number]['value'];

export type CsvRequestParams = {
  csvType: Type;
  encoding: Encoding;
  parameters: DealSearchCondition;
};
